import { render, staticRenderFns } from "./ClinicPrescriptions.vue?vue&type=template&id=35d86b3e"
import script from "./ClinicPrescriptions.vue?vue&type=script&lang=js"
export * from "./ClinicPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./ClinicPrescriptions.vue?vue&type=style&index=0&id=35d86b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports